module.exports = __webpack_public_path__ + "img/about-pic1@3x.879d5a99.png";